module.exports = __webpack_public_path__ + "img/lianghao_icon.8fd3e48e.gif";